<template>
  <div class="rolelist" style="height: 100%; width: 100%; margin: 0 auto">
    <Scene
      v-if="true"
      @localDatasave="localDatasave"
      @setT9video="setT9video"
      @cleanLocal="cleanLocal"
      @showSceneChange="showSceneChange"
      @selector="selector"
      :t9video="t9video"
    >
    </Scene>
    <loading
      :width="100"
      loader="dots"
      color="#ffacb7"
      :active="actionLoading"
      background-color="transparent"
    />
    <!-- 商品组件 -->
    <tab-commodity
      @getscens="getscens"
      @setScene="setScene"
      v-if="activeFun == 'commodity'"
      ref="tabCommodity"
      :t9video="t9video"
      :width="65"
    >
    </tab-commodity>
    <!-- 字幕组件 -->
    <tab-subtitle
      @getscens="getscens"
      @setScene="setScene"
      v-else-if="activeFun == 'subtitle'"
      ref="tabSubtitle"
      :t9video="t9video"
      :width="65"
    >
    </tab-subtitle>
    <!-- 动作组件 -->
    <tab-action
      style="display: none"
      v-else
      :user="user"
      ref="tabAction"
      :width="65"
      @isAction="isAction"
      @isshow="isshow"
    />

    <!-- <button @click="$router.push('/test')">测试</button> -->
    <div class="rightmodel" style="display: none">
      <div class="aiandface">
        <!--视频标签-->
        <div
          class="canvas-video"
          id="face-video"
          v-show="
            !windowParam.isWindows &&
            v2cParam.videoForm &&
            !windowParam.isWindowsFull
          "
        >
          <span class="close" @click="closeVideo" v-if="false">
            <i class="iconfont icon-guanbi"></i>
          </span>
          <div class="video-box">
            <video
              id="inputVideo"
              autoplay
              muted
              playsinline
              width="300"
              height="230"
              style="border-radius: 10px"
            ></video>
            <canvas
              id="overlay"
              v-show="v2cParam.videoOpen"
              width="300"
              height="230"
              style="background-color: transparent"
            ></canvas>
            <div class="distgrid" v-if="v2cParam.videoloading">
              <div class="wgrid"></div>
              <span
                style="
                  position: absolute;
                  z-index: 1;
                  color: #fff;
                  transform: scaleX(-1);
                  right: 0;
                  text-align: center;
                  top: 308px;
                  display: block;
                  width: 100%;
                  font-size: 30px;
                "
                >视频数据解析中</span
              >
            </div>

            <div
              class="video-back"
              v-if="!v2cParam.videoOpen"
              style="background-color: rgb(30 30 30)"
            >
              <div class="back-btn">
                <i class="iconfont icon-renlianshibie"></i>
              </div>
            </div>
          </div>

          <div
            class="video-fps"
            v-show="v2cParam.fps >= 1"
            :class="{
              good: v2cParam.fps >= 8,
              success: v2cParam.fps >= 12 || v2cParam.fps == 0,
              bad: v2cParam.fps < 8 && v2cParam.fps > 0,
            }"
          >
            <div class="fts">
              <span v-if="v2cParam.fps >= 12">正常({{ v2cParam.fps }})</span
              ><span
                v-if="
                  v2cParam.fps != 0 && v2cParam.fps >= 8 && v2cParam.fps < 12
                "
                >性能不足({{ v2cParam.fps }})</span
              ><span v-if="v2cParam.fps != 0 && v2cParam.fps < 8"
                >性能严重不足({{ v2cParam.fps }})</span
              >
            </div>
          </div>

          <div class="video-btn" v-show="!isFirstOpen" @click="videoOpenClose">
            {{ v2cParam.faceloaded ? "启动中..." : "开启摄像头-动作捕捉" }}
          </div>

          <div class="v2cloading" v-if="!modelloading && faceinitloading">
            <img
              src="@/assets/images/20130527034916434.gif"
            /><br />动捕系统初始化中
          </div>
          <!-- 按钮组 -->
          <div>
            <ul class="bom_btn" style="">
              <li
                v-tooltip="{ content: '开始动捕' }"
                v-show="!isFirstOpen"
                @click="videoOpenClose"
              >
                <i class="iconfont icon-weibiaoti518"></i>
              </li>
              <li
                v-show="isFirstOpen"
                v-tooltip="{ content: '结束动捕' }"
                @click="closeVideo"
              >
                <i class="iconfont icon-weibiaoti517"></i>
              </li>
              <li
                v-tooltip="{
                  content: '切换面部捕捉',
                }"
                v-show="aioption.body_pose"
                @click="changeWay()"
              >
                <i class="iconfont icon-rentijiance"></i>
              </li>
              <li
                v-show="!aioption.body_pose"
                v-tooltip="{
                  content: '切换半体捕捉',
                }"
                @click="changeWay()"
              >
                <i class="iconfont icon-yonghuming"></i>
              </li>
              <li @click="jiaozhun()"><i class="iconfont icon-shuaxin"></i></li>
              <li
                v-tooltip="{ content: '设置' }"
                @click="isShowSet = !isShowSet"
              >
                <i class="iconfont icon-shezhi"></i>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div class="scene">
        <div class="scene-box" :style="changjingbg">
          <div class="scene-title">
            <div class="title" @click="visibleBase = true">
              <i class="iconfont icon-shezhi"></i><span>基础设置与保存</span>
            </div>
            <div
              class="openScene"
              @click="selector_box_show = true"
              v-if="false"
            >
              <span class="img iconfont icon-yuanqu"></span>
              <span>修改场景背景</span>
            </div>

            <div class="btn">
              <span @click="selector_scene_show = true"
                ><i class="iconfont icon-tihuan"></i> 切换</span
              >
            </div>
          </div>
        </div>
        <div class="scene-box">
          <div class="scene-items">
            <!-- <div class="scene-item" @click="addOrEdit" style="color: #f082a2">
              <span class="img iconfont icon-baocun1"></span>保存场景
            </div> -->
            <!-- 拖拽排序组件 -->
            <draggable
              v-model="t9video.videoobj.scenes[0].res"
              handle=".move"
              chosen-class="chosen"
              ghost-class="ghost"
              @end="dragEnd"
            >
              <transition-group>
                <div
                  class="scene-item"
                  :class="{
                    active: ires.resid == activeFun,
                  }"
                  v-for="(ires, i) in t9video.videoobj.scenes[0].res"
                  :key="i + 'res'"
                  @click="changeTab(ires.resid, ires.restype, i)"
                >
                  <span
                    v-if="ires.resimg"
                    class="img move"
                    :style="{
                      backgroundImage: 'url(' + ires.resimg + ')',
                      backgroundSize: 'cover',
                    }"
                  ></span>
                  <span
                    class="move img iconfont icon-shangyong"
                    v-if="ires.restype == 3"
                  ></span>
                  <span
                    class="move img iconfont icon-zimuku"
                    v-if="ires.restype == 'subtitle'"
                  ></span>
                  {{ ires.resname }}
                  <div
                    style="position: absolute; right: 5px"
                    v-if="ires.restype != 1"
                  >
                    <button @click="deleteres(ires.resid)">删除</button>
                    <!-- <button @click="deleteres(ires.resid)">切换</button> -->
                  </div>
                  <div
                    style="position: absolute; right: 5px"
                    v-if="ires.restype == 1"
                  >
                    <!-- <button @click="changeRole(ires.resid)">切换</button> -->
                    <button @click="$router.push('/setrole')">切换</button>
                  </div>
                </div>
              </transition-group>
            </draggable>

            <div class="scene-item" @click="selector_scene_assembly.bottom = 0">
              <span class="img iconfont icon-out-column"></span>
              添加场景组件
            </div>
          </div>

          <div class="scene-addmenu" :style="selector_scene_assembly">
            <div class="addmenu-title">
              <span><strong>请选择要添加的组件</strong></span>
              <span
                class="close"
                @click="selector_scene_assembly.bottom = '-400px'"
                ><i class="iconfont icon-guanbi"></i
              ></span>
            </div>
            <div class="assemblymenu" v-if="false">
              <i class="iconfont icon-yonghuming"></i>角色组件
              <span class="only">单个</span>
            </div>
            <div class="assemblymenu" v-if="false">
              <i class="iconfont icon-test-108"></i>旁白组件
              <span class="only">单个</span>
            </div>
            <div class="assemblymenu" @click="pushRes('imgs')">
              <i class="iconfont icon-wodedaoju"></i>图片挂件
              <span class="unonly">多个</span>
            </div>
            <div class="assemblymenu" @click="pushRes('subtitle')">
              <i class="iconfont icon-tianjiazimu"></i>字幕组件
              <span class="only">单个</span>
            </div>
            <div class="assemblymenu" @click="pushRes('commodity')">
              <i class="iconfont icon-shangyong"></i>商品组件
              <span class="only">单个</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 背景选择器 -->
    <div class="selector_box" v-if="selector_box_show">
      <div class="selector_box_content">
        <bgSelector
          :user="user"
          :t93d="t9render"
          @selector="updateBack"
        ></bgSelector>

        <div class="selector_box_close" @click="selector_box_show = false">
          <i class="iconfont icon-guanbi"></i>
        </div>
      </div>
    </div>
    <!-- 背景改为场景选择器 -->
    <div class="selector_box" v-if="selector_scene_show">
      <div class="selector_box_content">
        <TabScene :user="user" @selector="selector"></TabScene>
        <div class="selector_box_close" @click="selector_scene_show = false">
          <i class="iconfont icon-guanbi"></i>
        </div>
      </div>
    </div>
    <!--性能提示-->
    <div
      v-if="v2cParam.winshow && !windowParam.isWindowsFull"
      style="width: 80%;background: #e5425b;    color: #fff;    position: absolute;    z-index: 99;    left: 10%;    padding: 15px;    text-align: center;
    border-radius: 0 0 20px 20px; top:0;   font-size: 16px;}"
    >
      <i class="iconfont icon-gantanhao"></i> 【计算机性能严重不足!】
      请关闭其它全部非必要应用程序再试!
      <a target="_blank" href="https://t-9.cn/news/1519628992116822016"
        >查看帮助</a
      >
      <span @click="v2cParam.winshow = false"
        >【<i class="iconfont icon-guanbi"></i>】</span
      >
    </div>
    <!-- 面部设置弹窗 -->
    <div class="setting setup" id="setup" v-if="isShowSet">
      <div class="set_content">
        <div class="tab-content">
          <div class="menu tab_action tab_bg">
            <div class="backtop">
              <span class="btncenter">设置</span>
              <div @click="isShowSet = false" class="chatbox_close">
                <i class="iconfont icon-guanbi"></i>
              </div>
            </div>
            <TabFace :user="user" @videoSelect="videoSelect" />
          </div>
        </div>
      </div>
    </div>
    <!-- 新增场景命名弹窗 -->
    <TDialog
      :visible.sync="visible"
      width="30%"
      title="场景模板命名"
      @close="cancel"
    >
      <input
        v-model.trim="t9video.videoobj.scenes[0].scenetitle"
        class="input"
        type="text"
      />
      <template v-slot:footer>
        <button
          style="background-color: #78aff9; margin-right: 10px"
          @click="saveScene"
        >
          确定
        </button>
      </template>
    </TDialog>
    <!-- '基础设置弹窗' -->
    <TDialog
      top="0"
      :visible.sync="visibleBase"
      width="40%"
      title="基础设置"
      @close="cancel"
    >
      <!-- 使用v-slot指定插槽进行编辑 -->
      <div class="item-row">
        <div class="item-name">场景模板名称:</div>
        <input
          v-model.trim="t9video.videoobj.scenes[0].scenetitle"
          class="input"
          type="text"
          style="width: 50%; margin: 0 0 0 20px"
        />
      </div>
      <div class="item-row">
        <div class="item-name">渲染器窗口宽高:</div>
        <div class="item-value">
          高度:<input
            v-int
            type="number"
            v-model.number="t9video.videoobj.scenes[0].height"
            style="width: 50px"
          />
        </div>
        <div>
          宽度:<input
            v-int
            type="number"
            v-model.number="t9video.videoobj.scenes[0].width"
            style="width: 50px"
          />
        </div>
      </div>
      <div class="item-row">
        <div>场景模板背景:</div>
        <div
          class="item-value"
          style="
            width: 200px;
            height: 150px;
            line-height: 150px;
            text-align: center;
            border-radius: 10px;
            overflow: hidden;
          "
        >
          <div class="scene-box" :style="changjingbg">
            <div class="openScene" @click="selector_box_show = true">
              <span class="img iconfont icon-yuanqu"></span>
              <span>修改场景背景</span>
            </div>
          </div>
        </div>
      </div>
      <div class="item-row" v-if="false">
        <div>场景模板背景声音:</div>
      </div>
      <template v-slot:footer>
        <button
          style="background-color: #78aff9; margin-right: 10px"
          @click="addOrEdit"
        >
          确定
        </button>
        <!-- <button @click="visible = false">取消</button> -->
      </template>
    </TDialog>
    <!--挂件选择器-->
    <PendantSelector
      v-if="guajiansel"
      :user="user"
      @backfun="successguajian"
    ></PendantSelector>
  </div>
</template>

<script>
var mycv
import { dataURLtoBlob, localData, asyncLoadJs, getRole, validate, getUserConfig } from '@/components/util/util_fun.js'
import { T9Video } from '@/components/video/t9video.js'
import { t9oss } from '@/components/util/util.js'
import { uploadFile } from '@/components/util/alioss.js'
import ToggleSwitch from '@/components/v-switch/index.vue'
import draggable from 'vuedraggable'
export default {
  name: 'PersonLive',
  components: {
    Scene: () => import('@/components/scene/index.vue'),
    // ToggleSwitch,
    draggable,// 拖拽排序组件
    TabAction: () => import(/*webpackChunkName:"TabAction"*/'@/views/role/menu/TabAction.vue'),
    TabCommodity: () => import(/*webpackChunkName:"TabCommodity"*/'@/views/role/menu/TabCommodity.vue'),
    TabSubtitle: () => import(/*webpackChunkName:"TabCommodity"*/'@/views/role/menu/TabSubtitle.vue'),

    bgSelector: () => import(/*webpackChunkName:"bgImgSelect"*/'@/views/setup/TabBg.vue'),
    TabScene: () => import(/*webpackChunkName:"TabScene"*/'@/views/setup/TabScene.vue'),
    TabFace: () => import(/*webpackChunkName:"TabFace"*/'@/views/operate/TabFace.vue'),
    PendantSelector: () => import(/*webpackChunkName:"PendantSelector"*/'@/views/selector/PendantSelector.vue'),


  },
  data () {
    return {
      resIndex: 0,// 当前选中的资源索引
      showGoodsSet: false,// 商品设置弹窗
      guajiansel: false,//挂件选择器
      // sceneName: '',// 场景模板名称
      sceneCover: '',// 场景模板封面
      visible: false, //对话框
      visibleBase: false,//基础设置弹窗
      activeFun: 1, // 切换场景设置页面1,人物,3商品设置
      isShowSet: false, //面捕设置弹出层
      actionLoading: true,
      color: '#0f0',
      size: '66px',
      selector_box_show: false,// 显示背景选择器弹窗
      selector_scene_show: false,// 显示场景选择器弹窗
      selector_scene_assembly: {
        bottom: "-400px"
      },// 添加组件
      t9render: t9render,
      t9video: null,
      user: null,
      aioption: { //可配置参数
        rate: 30,//AI分析频率，每秒识别次数，建议（15-30）
        inputSize: 160, //识别使用的图片尺寸，越大性能越低，人站的越远，这个数要求越大
        scoreThreshold: 0.5,//数据置信度要求，因使用微型模型，别超过0.7
        eye_sensitivity: 1.5, //一般在0.1-0.4之间
        eye_iris: true,
        body_pose: false,
      },
      v2cParam: {
        faceJSloading: true,//面捕预热加载
        videoForm: true,//面捕窗口
        videoOpen: false,//面捕状态是否开启
        videoloading: false,//面捕loading
        logTips: "",//加载日志
        fps: 0,//帧率
        faceloaded: false,
        xingneng: [],//用于存储当前性能集合
        winshow: false //是否需要在页面上显示性能提示
      },
      windowParam: {//窗口模式下的参数
        isWindows: false,//是否为窗口electron模式
        isWindowsFull: false,//窗口程序的全屏,
      },
      isFirstOpen: false,//开始面捕按钮显示隐藏
      modelloading: false,//模型loading
      faceinitloading: false,
      userconfig: getUserConfig(),//用户的配置信息
      xingneng: { //性能计算
        count: 0, starttime: 0
      },
      v2cobj: {},//面捕输入参数
      v2cOutParam: {},//t9输出参数
      changjingbg: {},//场景背景与设置相关(之前业务,现场景背景已抽离)
    }
  },
  // 监听t9video对象
  // watch: {
  //   t9video (newValue, oldValue) {
  //     // console.log('监听t9video改变')
  //   // console.log('t9video监听', newValue, oldValue)
  //   },
  //   //深度监听
  //   deep: true
  // },
  created () {
    // 验证是否过期
    var exp = validate()
    if (exp == '') {
      this.$store.commit('logout', {})
      location.href = '/vup/#/login'
      return
    }
    // console.log(this.$route.params)
    this.user = getRole(this.$route.params.user)

    // //初始化面捕系统  -- // 移动到开启面捕时进行初始化
    // if (!this.windowParam.isWindows) {
    //   //初始化面捕
    //   this.initFaceVideo()
    // } else {
    //   this.v2cParam.faceJSloading = false
    // }
    // 初始化t9video
    this.t9Init()


    // window.t9render.setScene(this.t9video.videoobj.scenes[0])
    this.$nextTick(() => {
      // window.t9render.sendScens = this.getscens
    })
    // console.log('created结束 ',)

  },
  mounted () {
    // 这是人脸的点点
    mycv = document.getElementById('overlay')
  },
  beforeDestroy () {
    // console.log('人控页面销毁前')
    // localData("set", "videoobj-new", this.t9video.videoobj)//暂时保存本地
    // this.localDatasave()
  },
  beforeRouteLeave (to, from, next) { // vue-router的钩子函数(离开路由之前)
    t9render.modelclose()
    next()
  },
  computed: {
    name () {
      return this.data
    }
  },


  methods: {



    // -----------------------------------------
    showSceneChange () {
      console.log('显示场景切换')
      this.selector_scene_show = !this.selector_scene_show
    },

    setT9video (obj) {
      console.log('子组件调用的setT9video方法传输scene对象', obj)
      this.$set(this.t9video.videoobj.scenes, 0, obj)
      this.localDatasave()
    },
    cleanLocal () {
      localData('clean', "videoobj-new")

    },
    // -----------------------------------------
    pushRes (type) {
      switch (type) {
        case 'subtitle':
          // 判断数组中是否已经有restype=subtitle的数据
          let subtitleI = this.t9video.videoobj.scenes[0].res.findIndex(item => item.restype == 'subtitle')
          if (subtitleI == -1) {
            this.t9video.videoobj.scenes[0].res.unshift({
              resid: 'subtitle',
              restype: 'subtitle',
              resobj: { fontsize: 24, fontcolor: '#F4F4F4' },
              resname: '字幕组件',
              startend: [0, 0],
              timeline: []
            })
          } else {
            this.$message.error('已经存在字幕组件')
          }
          break
        case 'imgs':
          this.guajiansel = true

          break

        case 'commodity':
          let commodityI = this.t9video.videoobj.scenes[0].res.findIndex(item => item.restype == 3)
          if (commodityI == -1) {
            this.t9video.videoobj.scenes[0].res.unshift({
              resid: "commodity",
              resname: "商品组件",
              resobj: {
                type: "commodity",
                textname: { //名字
                  fontsize: "20",
                  fontcolor: "#FFFFFF",
                  x: 10,
                  y: 500,
                  opacity: 1
                },
                textprice: { //价格
                  fontsize: "20",
                  fontcolor: "#FFFFFF",
                  x: 10,
                  y: 540,
                  opacity: 1
                },
                textnum: { //编号
                  fontsize: "20",
                  fontcolor: "#FFFFFF",
                  x: 10,
                  y: 580,
                  opacity: 1
                },
                textdesc: { //描述，字幕
                  fontsize: "20",
                  fontcolor: "#FFFFFF",
                  x: 10,
                  y: 800,
                  opacity: 1
                },
                textimg: { //图片
                  x: 10,
                  y: 20,
                  time: 4,//商品图片切换间隔
                  width: 250,
                  height: 250,
                  opacity: 1
                }
              },
              restype: 3,
              startend: [0, 0], //起止时间，单位秒，0为未设置
              timeline: [
              ]
            })
            this.setScene()
          } else {
            this.$message.error('已经存在商品组件')
          }

          break
      }

      this.selector_scene_assembly.bottom = '-400px'
    },
    setScene (obj) {
      if (obj) {
        console.log('人控子组件调用的setScene方法', obj)
        this.t9video.videoobj.scenes[0] = obj
        window.t9render.setScene(this.t9video.videoobj.scenes[0])
      } else {
        console.log('人控组件调用的setScene方法', obj)

        window.t9render.setScene(this.t9video.videoobj.scenes[0])
      }
    },
    getscens (obj) {
      console.log("人控页面接收场景变化", obj)
      // if (obj.res.length != 0) {
      // $set维持数据响应式
      this.$set(this.t9video.videoobj.scenes, 0, obj)
      this.localDatasave()
      if (this.$refs.tabCommodity) {
        this.$refs.tabCommodity.transfrom()

      }
      // }
    },
    t9Init () {
      // console.log('在creadted打印video', localData("get", "videoobj-new"))

      let tts = localData("get", "videoobj-new")
      if (tts) {
        this.t9video = new T9Video(tts)
        // console.log('本地存储的上一次video数据', tts)
        // if(this.t9video.this.t9video.videoobj.scenes[0].res.length==0){
        // }
      }
      else {
        this.t9video = new T9Video()
        // 如果没有资源，增加一个
        this.t9video.respush(this.user, 1)
        // this.t9video.videoobj.scenes[0].scene.gradient = 'background:radial-gradient(circle,#3b424a, #171c1c 67%)'
      }
      // 如果restype为1,返回索引
      let roleIndex = this.t9video.videoobj.scenes[0].res.findIndex((item) => item.restype == 1)
      // console.log('当前角色的索引', roleIndex)
      if (roleIndex != -1) {
      } else {
        let tl = this.user
        this.t9video.videoobj.scenes[0].res.push({
          resid: this.user.rolesId,
          resname: this.user.rolesName,
          resobj: this.user,
          restype: 1,
          startend: [0, 0],
          timeline: []
        })
      }
      if (this.t9video.videoobj.scenes[0].scene.gradient) {
        this.changjingbg = this.t9video.videoobj.scenes[0].scene.gradient
        // // console.log('this.changjingbg', this.changjingbg)
      } else if (this.t9video.videoobj.scenes[0].scene.materialPath) {
        this.changjingbg.background = `center/cover url(${this.t9video.videoobj.scenes[0].scene.materialPath})`
      } else {
        // this.changjingbg.background = "radial-gradient(circle,#3b424a, #171c1c 67%)"
      }
      if (this.$route.params.user) {
        console.log('切换的user', this.$route.params.user)
        var tl = this.t9video.videoobj.scenes[0].res[roleIndex]
        if (tl) {
          //无论时间线中的人物是谁，都改成当前角色
          tl.resid = this.user.rolesId
          tl.resimg = this.user.rolesPhoto//资源封面
          tl.resname = this.user.rolesName//资源名称
          tl.resobj = this.user
          delete tl.position
          delete tl.rotation
          delete tl.scale
          delete tl.opacity
        }

      }
      this.localDatasave()
      this.setScene()

      // console.log('初始化完成', this.t9video)
    },
    deleteres (id) {
      // 通过id查询索引
      let index = this.t9video.videoobj.scenes[0].res.findIndex((item) => item.resid == id)
      this.t9video.videoobj.scenes[0].res.splice(index, 1)
      this.localDatasave()
      this.setScene()


      // console.log(this.t9video.videoobj)
    },
    //挂件选择器
    successguajian (obj) {
      this.guajiansel = false
      this.t9video.respush(obj, 2)
      window.t9render.setScene(this.t9video.videoobj.scenes[0])
    },
    cancel () {
      this.visible = false
      this.visibleBase = false
      // this.sceneName = ''
    },
    // 点击场景元素切换主页面组件1,人物,3,商品组件
    changeTab (id, type, i) {
      // console.log('所选元素id', id)
      this.t9render.Scenesel(id)
      this.activeFun = id

    },
    addOrEdit () {
      if (this.t9video.videoobj.scenes[0].scenetitle == '') {
        return this.$message.error('请输入场景名称')
      }
      this.localDatasave()
      // console.log('保存的id', this.t9video.videoobj.scenes[0].sceneId)
      // return
      if (!this.t9video.videoobj.scenes[0].sceneId || this.t9video.videoobj.scenes[0].sceneId.length == 1) {
        // this.visible = true
        this.saveScene()
      } else {
        this.editScene()
      }
    },
    editScene () {
      this.actionLoading = true
      this.$message.warning('保存中...')
      this.t9render.screenshot((data) => {
        var that = this
        var newurl = '/stageImg/cover/'
        var name = newurl + "/scene_cover_" + new Date().getTime() + ".png"
        uploadFile(name, dataURLtoBlob(data), function (progress) {
          // 上传进度
          // console.log("封面上传进度：" + progress)
        }, function (results) {
          var url = t9oss + results.name//results.res.requestUrls[0].split("?uploadId=")[0];
          // console.log('url', url)
          // return
          that.t9video.videoobj.scenes[0].sceneCover = url
          that.post("/scene/modfiy", { sceneId: that.t9video.videoobj.scenes[0].sceneId, sceneName: that.t9video.videoobj.scenes[0].scenetitle, sceneDetails: JSON.stringify(that.t9video.videoobj.scenes[0]), sceneType: 2, sceneCover: url }).then(res => {
            // console.log('保存场景3', res)
            that.$message.success('修改成功')
            that.actionLoading = false
            that.cancel()

          })
        }, function (err) {
          that.$message.error('修改失败')
          // console.log("封面上传失败！" + err)
          that.cancel()
          that.actionLoading = false
          // that.saveCenter();
          return err
        })

      }, 'scene')
    },
    //上传场景封面(暂时不用)
    uploadCover (blob) {
      var that = this
      var newurl = '/stageImg/cover/'
      var name = newurl + "/scene_cover_" + new Date().getTime() + ".png"
      uploadFile(name, blob, function (progress) {
        // 上传进度
        // console.log("封面上传进度：" + progress)
      }, function (results) {
        var url = t9oss + results.name//results.res.requestUrls[0].split("?uploadId=")[0];
        // console.log('url', url)
        that.sceneCover = url
        return url
      }, function (err) {
        // console.log("封面上传失败！" + err)
        // that.saveCenter();
        return err
      })
    },
    saveScene () { //保存当前编辑场景
      if (this.t9video.videoobj.scenes[0].scenetitle == '') {
        return this.$message.error('请输入场景名称')
      }
      this.localDatasave()
      // 获取当前渲染器的截图
      this.actionLoading = true
      this.$message.warning('保存中...')
      this.t9render.screenshot((data) => {
        var that = this
        var newurl = '/stageImg/cover/'
        var name = newurl + "/scene_cover_" + new Date().getTime() + ".png"
        uploadFile(name, dataURLtoBlob(data), function (progress) {
          // 上传进度
          // console.log("封面上传进度：" + progress)
        }, function (results) {
          var url = t9oss + results.name//results.res.requestUrls[0].split("?uploadId=")[0];
          that.t9video.videoobj.scenes[0].sceneCover = url
          that.post("/scene/save", { sceneName: that.t9video.videoobj.scenes[0].scenetitle, sceneDetails: JSON.stringify(that.t9video.videoobj.scenes[0]), sceneType: 2, sceneCover: url }).then(res => {
            that.selector(res.data.sceneId)
            that.$message.success('保存成功')
            that.actionLoading = false
            that.cancel()

          })
        }, function (err) {
          // console.log("封面上传失败！" + err)
          that.actionLoading = false
          that.cancel()

          // that.saveCenter();
          return err
        })

      }, 'scene')


    },
    /**
    * 拖拽排序后触发
    */
    dragEnd () {

      // console.log('拖拽排序后触发', this.t9video.videoobj.scenes[0].res)
      // window.t9render.setScene(this.t9video.videoobj.scenes[0])
      this.setScene()
      this.localDatasave()

      // this.gaile = true
      // this.timelineto();
    },
    localDatasave () {
      // 判断当前路由
      let roleIndex = this.t9video.videoobj.scenes[0].res.findIndex((item) => item.restype == 1)
      this.user = this.t9video.videoobj.scenes[0].res[roleIndex].resobj
      localData("set", "videoobj-new", this.t9video.videoobj)//暂时保存本地
    },
    selector (sid) {
      // console.log('选择内容模板id', sid)
      if (sid == '') {
        // console.log('自定义模板')
        localData('clean', "videoobj-new")
        this.t9Init()

        this.localDatasave()
        // this.setScene()
      } else {
        if (sid.length == 1) {
          this.get('/vup/static/config/scenes.json').then((res) => {
            res.data.forEach(item => {
              if (item.sceneId == sid) {
                // console.log(item)
                this.t9video.videoobj.scenes.splice(0, 1, item)
                // this.t9render.setScene(this.t9video.videoobj.scenes[0])
                this.setScene()
                this.upminiback(item.scene)
                // localData("set", "videoobj-new", this.t9video.videoobj)//暂时保存本地
                // console.log('this.t9video.videoobj', this.t9video.videoobj)
                this.localDatasave()
              }
            })
          })

        } else {
          this.post("/scene/getSceneInfo", { code: sid }).then((res) => {
            // console.log('获取到的场景信息', res.data)
            res.data.sceneDetails = JSON.parse(res.data.sceneDetails)
            res.data.sceneDetails.sceneId = res.data.sceneId
            this.t9video.videoobj.scenes.splice(0, 1, res.data.sceneDetails)
            // this.t9render.setScene(this.t9video.videoobj.scenes[0])
            this.setScene()
            this.upminiback(res.data.sceneDetails.scene)
            // localData("set", "videoobj-new", this.t9video.videoobj)//暂时保存本地
            // console.log('this.t9video.videoobj', this.t9video.videoobj)
            this.localDatasave()
          }).catch((fail) => { })
        }
      }
      this.selector_scene_show = false
    },
    upminiback (obj) { //将小窗口的背景展示修改下
      // debugger
      // console.log('选择内容', obj)
      if (obj.type) { //如果是纯色背景
        if (obj.type == 'transparent') {//透明
          // this.changjingbg.background = "radial-gradient(circle,#3b424a, #171c1c 67%)"
          this.changjingbg = Object.assign({}, this.changjingbg)
        }
        else {
          // debugger
          this.changjingbg = obj.gradient
        }
      } else { // 图片背景
        this.changjingbg = {}
        if (obj.color) {
          this.changjingbg.background = ` center/cover url(${obj.color.materialPath})`
          this.changjingbg = Object.assign({}, this.changjingbg)
        } else if (obj.materialPath) {
          this.changjingbg.background = ` center/cover url(${obj.materialPath})`
          this.changjingbg = Object.assign({}, this.changjingbg)
        }
        // console.log(obj);
      }
      // console.log('场景对象', this.changjingbg)
    },
    //修改背景色
    updateBack (color) {
      //缓存只能存json
      this.upminiback(this.t9video.videoobj.scenes[0].scene = color)
      this.t9video.videoobj.scenes[0].scene = color
      // console.log('存到t9video对象', this.t9video.videoobj.scenes[0])
      // window.t9render.setScene(this.t9video.videoobj.scenes[0])
      this.setScene()
      // this.localDatasave()
      // var json = { color: color }
      // this.setconfig("bg", json)
      this.selector_box_show = false
    },
    /**
    * 用户更新保存用户习惯
    */
    setconfig (name, newValue) {
      // console.log(name,newValue);
      this.userconfig[name] = newValue
      localData("set", "userconfig", this.userconfig)
      t9render.sendmsg({ type: "userconfig", data: this.userconfig })
    },


    isshow (show) {
      // 是否显示loading
      this.actionLoading = show
    },
    isAction (action) {
      // console.log('isAction子组件的调用父组件方法,子组件的action', action)
    },


    //摄像头change事件，未打开时触发
    videoSelect (deviceId) {
      // console.log('子组件携带相机id', deviceId)
      this.setconfig("camera", deviceId)//保存到用户习惯
      // this.ws.sendMsg(104, "切换摄像头", deviceId)

      if (!this.windowParam.isWindows && this.v2cParam.videoOpen) {

        face2ctoo.face_stop()
        var videoObj = { "video": true }
        if (deviceId != "") {

          //切换摄像头
          videoObj = { "video": { deviceId: deviceId } }
        }

        const videoEl = document.getElementById("inputVideo")
        var that = this
        navigator.mediaDevices.getUserMedia(videoObj).then(function (stream) {

          videoEl.srcObject = stream
          videoEl.onloadeddata = async function () {
            videoEl.play()
            that.getFacePoint()
          }
        })
      }
    },

    //打开或关闭面捕
    videoOpenClose () {
      // 移动到开启面捕时进行初始化
      //初始化面捕系统
      if (!this.windowParam.isWindows && window.face2ctoo == undefined) {
        //初始化面捕
        this.initFaceVideo()
      } else {
        this.v2cParam.faceJSloading = false
      }
      this.v2cParam.faceloaded = true//启动中
      this.beginGetVideoFace()

    },


    //初始面捕
    async initFaceVideo () {

      this.faceinitloading = true

      // console.log('face2ctoo参数', face2ctoo)
      //实例化动作捕捉
      // if (window.face2ctoo == undefined) { //如果没有实例化，就实例化
      window.face2ctoo = new v2c.t9f.T9_face2C(this.aioption)
      // }

      var that = this


      if (this.userconfig.motioncap == 1) {  //默认启动为面捕
        this.userconfig.motioncap = '0'
        this.setconfig('motioncap', '0')
        face2ctoo.option({ body_pose: false })
        this.aioption.body_pose = false

      }
      else {
        this.aioption.body_pose = false
        face2ctoo.option({ body_pose: false })
      }
      //读取模型（预热数据）
      face2ctoo.modeload().then(function () {
        that.faceinitloading = false
        // console.log("加载完成")
        that.v2cParam.faceJSloading = false
      }).catch(function (e) {
        that.v2cParam.faceJSloading = false
        that.$message.error("警告：面捕加载异常！")
      })

    },

    /**
     * 开始面捕
     */
    beginGetVideoFace () {
      //electron模式下
      if (this.windowParam.isWindows) {
        return
      }

      var that = this
      //web模式
      this.v2cParam.faceloaded = true //摄像头loading
      this.v2cParam.videoloading = true //识别loading
      var date = new Date()
      // console.log("开始加载摄像头:【" + date.getMinutes() + ":" + date.getSeconds() + "】")



      this.videoEl = document.getElementById("inputVideo")

      var videoObj = { "video": true }
      if (this.userconfig.camera != '') { //如果多个摄像头，并做出了选择
        //切换摄像头
        videoObj = { "video": { deviceId: this.userconfig.camera } }
      }

      navigator.mediaDevices.getUserMedia(videoObj).then((stream) => {
        this.videoEl.srcObject = stream
        this.videoEl.onloadeddata = async () => {
          this.videoEl.play()
          this.v2cParam.videoOpen = true
          this.isFirstOpen = true
          setTimeout(() => {

            this.getFacePoint()

          }, 100)

        }

      }).catch(function (err) {

        that.v2cParam.videoOpen = false
        that.v2cParam.faceloading = false
        that.v2cParam.videoloading = false
        if (err.name == "NotAllowedError") {
          that.$message.warning("请允许当前浏览器使用摄像头，否则无法开启面捕！")
        } else if (err.name == "NotReadableError") {
          that.$message.warning("请检查摄像头是否被其他设备占用！")
        } else {
          that.$message.warning("摄像头启动失败，请检查设备是否可用！" + err)
        }

      })

    },

    //开始拉取面捕数据
    async getFacePoint () {

      // t9render.updatet9db(JSON.parse(this.user.param).t9live2d);  
      // var date = new Date()
      // const videoEl = document.getElementById("inputVideo");
      // console.log("开始分析数据:【" + date.getMinutes() + ":" + date.getSeconds() + "】")

      //获得面捕数据
      face2ctoo.getlanmarks(this.videoEl, this.myfacel, mycv)
    },

    //重新初始化面捕数据。关闭摄像头后避免面孔扭曲
    initFaceData () {
      var v2cobj = {
        // crooked: 0,
        // eye_left: 10,
        // eye_right: 10,
        // eyebrow_left: 0,
        // eyebrow_right: 0,
        // face: [0,0],
        // iris_x: 0,
        // iris_y: 0,
        // mouth_height: 0,
        // mouth_width: 0,
      }

      t9render.bindAnimation(v2cobj)
      this.myfacel(v2cobj, "close")
    },

    xingnengtest () {

      var starttimed = this.xingneng.starttime
      if (starttimed == 0) {
        starttimed = new Date()
        this.xingneng.starttime = starttimed
      }

      let usedTime = new Date() - starttimed // 相差的毫秒数

      if (usedTime > 1000) //运行一秒了
      {
        this.v2cParam.fps = this.xingneng.count
        this.v2cParam.xingneng.push(this.xingneng.count) //记录性能
        if (this.v2cParam.xingneng.length >= 10) {
          this.v2cParam.xingneng.shift()//移除第一个数据
        }
        //筛选性能比较低的值有多少
        var xnbl = this.v2cParam.xingneng.filter(function (xn) {
          return xn <= 8
        })
        if (xnbl.length > 5)//如果超出5个，就要提示
        {
          this.v2cParam.winshow = true
        }
        else {
          this.v2cParam.winshow = false
        }
        // console.log(this.v2cParam.fps);
        this.xingneng.count = 0
        this.xingneng.starttime = new Date()
      }
      else {
        this.xingneng.count++
      }


    },

    //面捕回调
    myfacel (v2cobj, faceLandmarks) {
      console.log('面部回调', v2cobj, faceLandmarks)
      if (this.faceinitloading && this.aioption.body_pose) {
        this.faceinitloading = false
        this.actionLoading = false
      }
      //这是用于计算FTS性能
      this.xingnengtest()

      // t9render.updatet9db();
      // console.log(v2cobj);
      if (typeof (v2cobj) == "string") {
        console.log("v2c出现异常，重新加载：" + v2cobj)
        this.$message.warning("动作捕捉系统错误！")
        this.getFacePoint()
      }
      else if ((v2cobj && (this.v2cParam.videoOpen || this.windowParam.isWindows)) || faceLandmarks == "close") {

        this.v2cobj = v2cobj //用于实时显示参数


        t9render.runfunction("bindAnimation", [v2cobj])
        //这是空间移动，暂时不需要
        // if(faceLandmarks&&this.aioption.position){
        //     this.$emit("faceChange",faceLandmarks)
        // }

        //获得人脸数据后，将loading关掉
        if (this.v2cParam.faceloaded) {
          this.v2cParam.faceloaded = false
          this.v2cParam.videoloading = false
          //     this.$message.success("校准成功！");
          // if (this.user.type == 3 || this.user.type == 4) { //3D类型
          //   this.t93d.calibration()
          // } else { //2D 类型
          //   this.t9render.stopAnimation()
          // }
        }


        // this.v2cParam.fps=PixiCommon.getTickerFPS();
      } else {
        //未找到人
        // console.log('v2cobj', v2cobj)
        // console.log('this.v2cParam.videoOpen', this.v2cParam)
        // console.log('this.windowParam.isWindows', this.windowParam)
        // console.log("未找到人")
      }

    },

    openvideo () {  //打开视频录制窗口
      this.$router.push('/video')
    },


    //关闭摄像头
    closeVideo () {
      // console.log("关闭了摄像头")

      //初始数据
      this.v2cParam.faceloaded = false
      this.v2cParam.videoOpen = false


      //// t9render.calibration();
      //// t9render.l2dAutobreath();

      face2ctoo.face_stop()



      //暂停摄像头
      var thisVideo = document.getElementById("inputVideo")
      if (thisVideo && thisVideo.srcObject != undefined) {
        var trackList = thisVideo.srcObject.getTracks()
        if (trackList.length > 0) {
          for (let index = 0; index < trackList.length; index++) {
            if (trackList[index].readyState == "live") {
              trackList[index].stop()
            }
          }
        }
      }
      // thisVideo.srcObject = null

      // 显示开始面捕按钮
      this.isFirstOpen = false
      this.v2cParam.fps = 0

      this.restartAnimation()
    },

    /**
     * 面捕结束后，回复原有动画
     */
    restartAnimation () {
      // console.log("面捕结束")
      t9render.runfunction("captureend")

    },
    //面捕的重置校准功能，动作捕捉不需要校准
    jiaozhun () {
      this.v2cParam.videoloading = true

      // if (t9render) {
      //   t9render.calibration() //2D模型重置
      // }
      face2ctoo.calibration() //面捕重置

      this.$message.success("校准成功！")
      this.v2cParam.videoloading = false

    },
    //面捕弹框可拖动
    FaceFormMove () {

      var obj = document.getElementById("face-video")
      function MDown (event) {
        Obj = Object.id
        obj.setCapture()
        pX = event.x - obj.style.pixelLeft
        pY = event.y - obj.style.pixelTop
      }
      obj.onmousemove = function MMove (event) {
        obj.style.left = event.x - pX
        obj.style.top = event.y - pY
      }

      obj.onmouseup = function MUp () {
        obj.releaseCapture()
      }
    },
    goAiPage () {
      this.$router.push({
        //   path: '/personlive',
        name: 'AiLive',
        params: {
          "user": this.user,
        }
      })
    },
    // 切换面捕/动捕
    changeWay () {
      if (!this.v2cParam.videoOpen) return this.$message.warning("请打开摄像头！")
      this.userconfig = getUserConfig()
      if (this.userconfig.motioncap == '1') {
        // console.log('当前是动捕,切换为面捕')
        this.setconfig('motioncap', '0')
        this.aioption.body_pose = false
      } else {
        this.faceinitloading = true
        this.actionLoading = true
        // console.log('当前是面捕,切换为动捕')
        this.setconfig('motioncap', '1')
        this.aioption.body_pose = true
      }
      if (this.v2cParam.videoOpen) {
        // console.log('切换执行')
        face2ctoo.option(this.aioption)

      }
    }
  },
}
</script>

<style lang="scss" scoped>
.rightmodel {
  width: 30%;
  height: 100%;
  overflow-y: auto;

  .scene {
    // 场景选择
    position: relative;
    border-radius: 10px;
    overflow: hidden;
    .scene-box {
      .scene-title {
        // 场景头部
        padding: 10px;
        display: flex;
        justify-content: space-between;
        height: 150px;
        text-align: center;
        position: relative;
        overflow: hidden;
        .title {
          cursor: pointer;
          font-size: 16px;
          font-weight: bold;
        }
        :hover {
          color: #fff;
        }
        .openScene {
          position: absolute;
          left: 50%;
          top: 50%;
          transform: translate(-50%, -50%); /* 50%为自身尺寸的一半 */
          -webkit-transform: translate(-50%, -50%);
          cursor: pointer;
        }
        .btn {
          cursor: pointer;
        }
      }
      .scene-items {
        margin: 10px 5px;
        .scene-item {
          // 场景列表
          margin-bottom: 5px;
          // background-color: yellowgreen;
          display: flex;
          height: 40px;
          line-height: 40px;
          font-size: 14px;
          // margin-right: 5px;

          border-radius: 5px;
          text-align: center;
          flex-shrink: 0;
          cursor: pointer;
          position: relative;
          .img {
            font-size: 24px; // 修改icon大小
            margin-right: 5px;
            width: 40px;
            height: 40px;
            background-position: center;
            background-size: auto 100%;
            background-repeat: no-repeat;
            display: inline-block;
            border-radius: 5px;
          }
          &:hover {
            background-color: #fff;
            color: #000;
          }
        }
      }
    }
    .scene-addmenu {
      // 添加场景
      position: absolute;
      right: 0;
      bottom: -1000px;
      width: 100%;
      background-color: #fff;
      border-radius: 10px;
      z-index: 999;
      color: #666;
      box-shadow: -2px -5px 6px -4px rgba(25, 25, 25, 0.5);
      transition: all 0.3s;

      .assemblymenu {
        padding: 10px;
        border-bottom: 1px #ddd solid;
        cursor: pointer;
        i {
          font-size: 21px !important;
          margin-right: 10px;
        }

        &:hover {
          background-color: #f5f5f5;
        }
        .only {
          background-color: #ff5a52;
          color: #fff;
          font-size: 12px;
          border-radius: 5px;
          padding: 2px 5px;
          float: right;
        }
        .unonly {
          background-color: #39f;
          color: #fff;
          font-size: 12px;
          border-radius: 5px;
          padding: 2px 5px;
          float: right;
        }
      }

      .addmenu-title {
        display: flex;
        justify-content: space-between;
        padding: 10px;
        border-bottom: 1px #ddd solid;

        .close {
          cursor: pointer;
          font-size: 18px !important;
          margin-right: 10px;
        }
      }
    }
  }
  .bgset {
    border-radius: 10px;
    overflow: hidden;
    .bgupdate {
      width: 100%;
      height: 200px;

      text-align: center;
      line-height: 200px;
      cursor: pointer;
      position: relative;
      background-position: center !important;
      background-size: 100% auto !important;
      background-repeat: no-repeat !important;
      overflow: hidden;
      div {
        background-color: rgba(0, 0, 0, 0.5);
        color: #afa9a9;
        transition: all 1s;

        &:hover {
          color: #fff;
          background-color: rgba(0, 0, 0, 0.8);
        }
      }
    }
  }
}
.setDialog {
}
.menu {
  position: absolute;
  top: -64px;
  top: 0;
  width: 100%;
  left: 0;

  height: calc(100% + 64px);
  // background: #fff;
  .varbox {
    padding: 20px 0;
    line-height: 1.5em;
    // padding-left: 0;
    border-radius: 20px;
    div {
      display: flex;
      align-items: center;
      margin-bottom: 5px;
      line-height: 30px;
    }
    .pink {
      color: #f4acb7;
      margin: 0 5px;
    }
    .iconfont {
      margin-bottom: 0;
      margin-right: 4px;
      font-size: 20px !important;
    }
    .icon-cuowu {
      color: #ee012e;
    }
    .icon-zhengque {
      color: #01a411;
    }
  }
  // .content-box {
  //     margin: 0!important;
  // }
}

.tab_active {
  border: 3px solid #f4acb7;
  box-sizing: border-box;
}
.chatbox_close {
  position: absolute;
  z-index: 10;
  right: 0;
  top: 0;
  cursor: pointer;
  i {
    font-size: 26px !important;
  }
  &:hover i {
    color: #39f;
  }
}
#setup {
  width: 600px;
  height: 80%;
  left: 30%;
  border-radius: 10px;
  top: 90px;
  // box-shadow: 0px 8px 10px 1px;
}
.item-row {
  display: flex;
  // line-height: 35px;
  min-height: 35px;
  margin: 10px 0;
  .item-name {
    // margin: 0 auto; /*位置居中*/
  }
  .item-value {
    margin-left: 10px; /*位置居中*/
    .scene-box {
      color: #484848;
      :hover {
        cursor: pointer;
        color: #fff;
      }
    }
  }
}
.input {
  display: block; /*变为块元素*/
  width: 80%; /*设置宽度*/
  margin: 0 auto; /*位置居中*/
  outline: 0; /*点击时去除边框*/
  border: none; /*去除外边框*/
  background-color: #fff; /*设置背景色*/
  padding: 10px 10px; /*设置输入内容的上下边距*/
  border-radius: 4px; /*设置圆角*/
  box-shadow: inset 1px 1px 6px 0 rgba(0, 0, 0, 0.3); /*设置内部阴影*/
  transition: all 250ms; /*鼠标划过时监听所有变化250ms*/
  &:hover {
    background: #f5efef; /*鼠标滑过时背景颜色改变*/
    box-shadow: inset 1px 1px 6px 0 #e8eafc; /*鼠标划过时边框发生改变*/
  }
}
</style>